<template>
    <div class="chooseAddress">
        <myHeader :headerData="headerData"></myHeader>
        <div class="addressRow" v-for="item in addressData" @click="doSelected(item)">
            <p>
                <span>{{item.receiverName||'暂无收货人'}}</span>
                <span class="phoneNumber">{{item.receiverTel||'暂无收货人电话'}}</span>
            </p>
            <p class="addressContent">
                <span class="nowAddress" v-if="item.isChoose">[当前地址]</span>
                <span>{{(item.provinceName+item.cityName+item.countyName+item.roadDetail)||'暂无收货地址'}}</span>
            </p>
        </div>
    </div>
</template>

<script>
    import myHeader from '../components/header.vue';
    export default {
        name: 'chooseAddress',
        components: {
            myHeader
        },
        created: function () {
            this.getAddress();
        },
        methods: {
            getAddress(){
                var _this = this;
                var query=this.$route.query;
                if(query&&query.platform){
                    this.platform=query.platform;
                    this.headerData.platform=query.platform
                }
                this.$http.get(this.$api.QueryMyAddresses, {Platform:this.platform}, function (res) {
                    var data = res.content;
                    var addressId = sessionStorage.getItem('addressId')
                    for (var i = 0; i < data.length; i++) {
                        if (data[i].addressId == addressId) {
                            data[i].isChoose = true;
                        }
                    }
                    _this.addressData = res.content
                    _this.headerData.addressData  = res.content
                })
            },
            doSelected: function (item) {
//                if (window.webView) {
//                    var sendData = JSON.stringify(item);
//                    window.webView.exchange("selectedAddress", sendData)
//                }
                    this.$smartBridge.setResult({ postData: item });
                    this.$smartBridge.close();
            },
        },
        data () {
            return {
                headerData: {
                    name: '选择收货地址',
                    isOut: true,
                    save: false,
                    manage: true,
                    platform:'',
                    addressData:''
                },
                addressData: [],
                platform:''
            }
        }
    }
</script>
<style scoped>
    .addressRow {
        padding-bottom: 0;
    }

    .addressContent {
        border-bottom: 0;
    }

    .nowAddress {
        color: rgb(0, 172, 237);
    }
</style>



// WEBPACK FOOTER //
// src/pages/chooseAddress.vue